//import RouteCode from '../../../cross_inc/routes/routerCodes';

// router
let initialState = {
	
    //url: '',              // 
    routeName: '',
    //targetRouteName: '',    // следующий роут - если надо переключить потом куда-то
    //params: {},
    //pathArray: [],

};

export const routerReducer = (state = initialState, action) => {

    switch (action.type) {

        case ROUTER_SET_ROUTE_NAME:
            return {
                ...state,
                routeName: action.payload
            };

        // Bad but Fast Practice
        case ROUTER_UPDATE_PARAMS:
            return {
                ...state,
                ...action.payload,
            };

        default:
            break;
    }

    return state;
};

export const ROUTER_SET_ROUTE_NAME = 'ROUTER_SET_ROUTE_NAME';
export const setRouteName = (routeName) => {
    return {
        type: ROUTER_SET_ROUTE_NAME,
        payload: routeName,
    };
};

// Bad but Fast Practice
export const ROUTER_UPDATE_PARAMS = 'ROUTER_UPDATE_PARAMS';
export const updateRouterState = (newParams) => {
    return {
        type: ROUTER_UPDATE_PARAMS,
        payload: newParams,
    };
};